module.exports = __webpack_public_path__ + "img/support_c4.15235bb3.png";